var chartColors = {
    red: 'rgb(255, 99, 132)',
    orange: 'rgb(255, 159, 64)',
    yellow: 'rgb(255, 205, 86)',
    green: 'rgb(75, 192, 192)',
    blue: 'rgb(54, 162, 235)',
    purple: 'rgb(153, 102, 255)',
    grey: 'rgb(201, 203, 207)'
};

export var chartColorsInHex = {
    red: '#FF6384',
    orange: '#FF9F40',
    yellow: '#FFCD56',
    green: '#4BC0C0',
    blue: '#36A2EB',
    purple: '#36A2EB',
    grey: '#C9CBCF'
}

export default chartColors;